'use strict';

/**
 * Returns true if given object is native to this execution context,
 * false otherwise (e.g. because it came from another frame or vm).
 *
 * @param  {*}  obj
 * @return {Boolean}
 */
module.exports = function isNative (obj) {
  return (obj === null
    || obj === undefined
    || obj.constructor.constructor === Function);
};



// WEBPACK FOOTER //
// ./lib/rlink-type-utils/isNative.js